export default {
  props: {
    matches: {
      type: Array,
      required: true
    },
    index: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      highlightResearchers: {},
      highlightOrganisations: {},
      highlightResearchGroups: {},
      highlightKeywords: {},
      highlightAssignees: {},
      highlightInventors: {},
      highlightApplicants: {},
      clinicalTrialDescription: '',
      projectDescription: '',
      researchTopicDescription: '',
      descriptionDescription: '',
      abstractDescription: '',
      claimDescription: ''
    }
  },
  created () {
    this.initHighlights()
  },
  watch: {
    'highlights': {
      handler () {
        this.initHighlights()
      },
      deep: true
    }
  },
  methods: {
    initHighlights () {
      const hl = this.highlights

      for (let match of this.matches) {
        if (match.name === 'research_group') {
          if (!this.isEmpty(match.highlights)) this.highlightResearchGroups = match.highlights
          if (!this.isEmpty(hl) && !this.isEmpty(hl['research_groups.about'])) this.researchGroupDescription = hl['research_groups.about']
          if (!this.isEmpty(hl) && !this.isEmpty(hl['research_groups.description'])) this.researchGroupDescription = hl['research_groups.description']
        }

        if (match.name === 'publication') {
          if (!this.isEmpty(hl) && !this.isEmpty(hl['publications.abstract'])) this.abstractDescription = hl['publications.abstract']
        }

        if (match.name === 'project') {
          // title', 'objective', 'abstract', 'public_health_relevance_statement', 'project_outcomes_report
          if (!this.isEmpty(hl) && !this.isEmpty(hl['projects.objective'])) this.projectDescription = hl['projects.objective']
          if (!this.isEmpty(hl) && !this.isEmpty(hl['projects.summary'])) this.projectDescription = hl['projects.summary']
          if (!this.isEmpty(hl) && !this.isEmpty(hl['projects.abstract'])) this.projectDescription = hl['projects.abstract']
          if (!this.isEmpty(hl) && !this.isEmpty(hl['projects.public_health_relevance_statement'])) this.projectDescription = hl['projects.public_health_relevance_statement']
          if (!this.isEmpty(hl) && !this.isEmpty(hl['projects.project_outcomes_report'])) this.projectDescription = hl['projects.project_outcomes_report']
        }

        if (match.name === 'research_topic') {
          if (!this.isEmpty(hl) && !this.isEmpty(hl['research_topics.description'])) this.researchTopicDescription = hl['research_topics.description']
        }

        if (match.name === 'researcher' || match.name === 'participant') {
          if (!this.isEmpty(hl['researchers.full_name.normalized'])) this.highlightResearchers = hl
          if (!this.isEmpty(hl['participants.full_name.normalized'])) this.highlightResearchers = hl
          if (!this.isEmpty(hl['research_group.owners.full_name.normalized'])) this.highlightResearchers = hl
        }

        if (match.name === 'organisation') {
          if (!this.isEmpty(match.highlights)) this.highlightOrganisations = match.highlights
        }

        if (match.name === 'keyword') {
          if (!this.isEmpty(hl['keywords.keyword'])) this.highlightKeywords = hl
        }

        if (match.name === 'inventor') {
          if (!this.isEmpty(match.highlights)) this.highlightInventors = match.highlights
          if (!this.isEmpty(hl['inventors.name.normalized'])) this.highlightInventors = hl
          if (!this.isEmpty(hl['inventors.initial_name.normalized'])) this.highlightInventors = hl
        }

        if (match.name === 'applicant') {
          if (!this.isEmpty(match.highlights)) this.highlightApplicants = match.highlights
          if (!this.isEmpty(hl['applicants.name.normalized'])) this.highlightApplicants = hl
          if (!this.isEmpty(hl['applicants.full_name.normalized'])) this.highlightApplicants = hl
        }

        if (match.name === 'clinical_trial') {
          if (!this.isEmpty(hl) && !this.isEmpty(hl['clinical_trials.primary_objective'])) this.clinicalTrialDescription = hl['clinical_trials.primary_objective']
          if (!this.isEmpty(hl) && !this.isEmpty(hl['clinical_trials.secondary_objective'])) this.clinicalTrialDescription = hl['clinical_trials.secondary_objective']
        }

        if (match.name === 'claim') {
          if (!this.isEmpty(hl) && !this.isEmpty(hl['claims.claim'])) this.claimDescription = hl['claims.claim']
        }
      }

      if (!this.isEmpty(this.highlights)) {
        if (!this.isEmpty(this.highlights.about)) this.descriptionDescription = this.highlights.about
        if (!this.isEmpty(this.highlights.description)) this.descriptionDescription = this.highlights.description
        if (!this.isEmpty(this.descriptionDescription)) {
          this.descriptionDescription = this.stripTagsNoMark(this.descriptionDescription)
        }
      }
    }
  }
}
